<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import ItemTemplate from './ItemTemplate'

  export default {
    name: 'NewsTeaserHorizontal',
    components: {
      ItemTemplate,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
      commentsActive: Boolean,
    },
    data() {
      return {
        maxRecordsToShow: 10,
      }
    },
    computed: {
      articles() {
        return this.options.results && this.options.results.teasers || []
      },
      showMore() {
        return this.maxRecordsToShow < this.articles.length
      },
    },
    watch: {
      'options'() {
        this.maxRecordsToShow = 10
      },
    },
    methods: {
      viewMore() {
        this.maxRecordsToShow += 10
      },
      displayDescription(description) {
        return description.replace('<br>', '\n')
      },
    },
  }
</script>
